<template>
  <div>
    <div class="p-fluid p-mt-2 p-ml-4">
      <div class="p-formgrid p-grid p-justify-start p-mb-1" style="height: 80px;">
        <!-- <div class="p-field p-col-12 p-lg-4 p-mt-3">
          <label for="organize_name">{{ $t("organize_name") }}</label>
          <InputText id="organize_name" type="text" v-model="organize_name" />
        </div> -->
        <div class="p-field p-col-12 p-lg-12 p-mt-3">
          <label for="organizeTypeOptions">{{ $t("organize_type") }}</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-10 p-pt-0">
                  <MultiSelect
                    v-model="organizeType_select"
                    :options="organizeTypeOptions"
                    optionLabel="system_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.organize_name"
                      >
                        <div>{{ option.system_name }}</div>
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.system_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
          
           <div class="p-field p-col-1 p-lg-1 ">
                  <Button
                    @click="organizeType_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                   
                  />
                </div>
                
                <!-- <div class="p-col-1 p-lg-1">
              <Button
                @click="handleButtonClick()"
                :label="$t('searchBtn')"
                class="p-button-success"
                

              />
            </div> -->

        </div>
      </div>
      </div>

<!-- highwayDept -->
      <div v-if="this.highwayDept === true" class="p-formgrid p-grid" >
        <div class="p-field p-col-12 p-lg-5 p-mt-2" style="height: 60px;">
          <label for="highwayDeptOptions">กรมทางหลวง</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-11 p-lg-11 p-pt-0">
                  <MultiSelect
                    v-model="highwayDept_select"
                    :options="highwayDeptOptions"
                    optionLabel="system_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.id"
                      >
                        <div>{{ option.system_name }}</div>
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.system_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
          
           <div class="p-field p-col-1 p-lg-1 ">
                  <Button
                    @click="highwayDept_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
        </div>
      </div>
    </div>
<!-- highwayDept end -->

<!-- fireStationDept -->
    <div v-if="this.fireStationDept === true" class="p-formgrid p-grid">
      <!-- <div class="p-field p-col-12 p-lg-5 p-mt-2" style="height: 60px;">
          <label for="fireStationDeptOptions">กองปฏิบัติการดับเพลิงและกู้ภัย</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-11 p-lg-11 p-pt-0">
                  <MultiSelect
                    v-model="fireStationDept_select"
                    :options="fireStationDeptOptions"
                    optionLabel="organize_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.id"
                      >
                        {{ option.organize_name }}
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.organize_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
          
           <div class="p-field p-col-1 p-lg-1 ">
                  <Button
                    @click="fireStationDept_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
        </div>
      </div> -->

      <div class="p-field p-col-12 p-lg-5 p-mt-2 " style="height: 60px;">
          <label for="fireStationDeptLists">รายการกองปฏิบัติการดับเพลิงและกู้ภัย</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-11 p-lg-11 p-pt-0">
                  <MultiSelect
                    v-model="fireStationDeptLists_select"
                    :options="fireStationDeptLists"
                    optionLabel="organize_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.id"
                      >
                        {{ option.organize_name }}
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.organize_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
          
           <div class="p-field p-col-1 p-lg-1 ">
                  <Button
                    @click="fireStationDeptLists_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
        </div>
      </div>
      <!-- <div v-else class="p-field p-col-12 p-lg-6 p-mt-2" style="height: 60px;">
        <span></span>
      </div> -->
    </div>
    <!-- fireStationDept end -->

    <!-- districtAndBangkokDept -->
    <div v-if="this.districtAndBangkokDept === true" class="p-formgrid p-grid">
      <div class="p-field p-col-12 p-lg-8 p-mt-2" style="height: 60px;">
          <label for="districtAndBangkokDeptOptions">สำนักงานเขตและกรุงเทพมหานคร</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-7 p-pt-0">
                  <MultiSelect
                    v-model="districtAndBangkokDept_select"
                    :options="districtAndBangkokDeptOptions"
                    optionLabel="system_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.id"
                      >
                        <div>{{ option.system_name }}</div>
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.system_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
        
           <div class="p-field p-col-1 p-lg-1">
                  <Button
                    @click="districtAndBangkokDept_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
                <div class="p-field p-col-1 p-lg-4" style="margin-top: 5px;">
                  <small class="p-invalid" style="font-size: medium;" v-if="this.districtAndBangkokDept_error">
                    กรุณาเลือกอย่างน้อย 1 ตัวเลือก
                  </small>
                </div>
        </div>
        
      </div>
    </div>
    <!-- districtAndBangkokDept end -->

    <!-- disasterPreventionStrategyDept -->
    <div v-if="this.disasterPreventionStrategyDept === true" class="p-formgrid p-grid">
      <div class="p-field p-col-12 p-lg-8 p-mt-2" style="height: 60px;">
          <label for="disasterPreventionStrategyDeptOptions">สำนักงานยุทธศาสตร์การป้องกันสาธารณภัย</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-7 p-pt-0">
                  <MultiSelect
                    v-model="disasterPreventionStrategyDept_select"
                    :options="disasterPreventionStrategyDeptOptions"
                    optionLabel="organize_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.id"
                      >
                        <div>{{ option.organize_name }}</div>
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.organize_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
          
           <div class="p-field p-col-1 p-lg-1 ">
                  <Button
                    @click="disasterPreventionStrategyDept_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
                <div class="p-field p-col-1 p-lg-4" style="margin-top: 5px;">
                  <small class="p-invalid" style="font-size: medium;" v-if="this.disasterPreventionStrategyDept_error === true">
                    กรุณาเลือกอย่างน้อย 1 ตัวเลือก
                  </small>
                </div>
        </div>
      </div>
    </div>
    <!-- disasterPreventionStrategyDept end -->

    <!-- secretaryDept -->
    <div v-if="this.secretaryDept === true" class="p-formgrid p-grid">
      <div class="p-field p-col-12 p-lg-8 p-mt-2" style="height: 60px;">
          <label for="secretaryDeptOptions">สำนักงานเลขานุการ</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-7 p-pt-0">
                  <MultiSelect
                    v-model="secretaryDept_select"
                    :options="secretaryDeptOptions"
                    optionLabel="organize_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.id"
                      >
                        <div>{{ option.organize_name }}</div>
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.organize_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
          
           <div class="p-field p-col-1 p-lg-1 ">
                  <Button
                    @click="secretaryDept_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
                <div class="p-field p-col-1 p-lg-4" style="margin-top: 5px;">
                  <small class="p-invalid" style="font-size: medium;" v-if="this.secretaryDept_error === true">
                    กรุณาเลือกอย่างน้อย 1 ตัวเลือก
                  </small>
                </div>
        </div>
      </div>
    </div>
    <!-- secretaryDept end -->

    <!-- disasterDirectedDept -->
    <div v-if="this.disasterDirectedDept === true" class="p-formgrid p-grid">
      <div class="p-field p-col-12 p-lg-8 p-mt-2" style="height: 60px;">
          <label for="disasterDirectedDeptOptions">สำนักงานอำนวยการสาธารณภัย</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-7 p-pt-0">
                  <MultiSelect
                    v-model="disasterDirectedDept_select"
                    :options="disasterDirectedDeptOptions"
                    optionLabel="organize_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.id"
                      >
                        <div>{{ option.organize_name }}</div>
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.organize_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
          
           <div class="p-field p-col-1 p-lg-1 ">
                  <Button
                    @click="disasterDirectedDept_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
                <div class="p-field p-col-1 p-lg-4" style="margin-top: 5px;">
                  <small class="p-invalid" style="font-size: medium;" v-if="this.disasterDirectedDept_error === true">
                    กรุณาเลือกอย่างน้อย 1 ตัวเลือก
                  </small>
                </div>
        </div>
      </div>
    </div>
    <!-- disasterDirectedDept end -->

    <!-- disasterCenterDept -->
    <div v-if="this.disasterCenterDept === true" class="p-formgrid p-grid">
      <div class="p-field p-col-12 p-lg-8 p-mt-2" style="height: 60px;">
          <label for="disasterCenterDeptOptions">สำนักป้องกันและบรรเทาสาธารณภัย</label>
  
          <div class="p-formgrid p-grid">
          <div class="p-field p-col-10 p-lg-7 p-pt-0">
                  <MultiSelect
                    v-model="disasterCenterDept_select"
                    :options="disasterCenterDeptOptions"
                    optionLabel="system_name"
                    :placeholder="$t('placeholderSelectBox')"
                    :filter="true"
                    class="multiselect-custom"
                    :clearFilterMultiSelect="multiSelectClearFilerValue"
                  >
                    <template #value="slotProps">
                      <div
                        class="item item-value"
                        v-for="option of slotProps.value"
                        :key="option.id"
                      >
                        <div>{{ option.system_name }}</div>
                      </div>
                      <template
                        v-if="!slotProps.value || slotProps.value.length === 0"
                      >
                        {{ $t("placeholderSelectBox") }}
                      </template>
                    </template>
                    <template #option="slotProps">
                      <div class="item">
                        <div>{{ slotProps.option.system_name }}</div>
                      </div>
                    </template>
           </MultiSelect>
          </div>
          
           <div class="p-field p-col-1 p-lg-1 ">
                  <Button
                    @click="disasterCenterDept_select = null
                            multiSelectClearFilerValue +=1"
                    icon="pi pi-times"
                    class="p-button-danger"
                  />
                </div>
                <div class="p-field p-col-1 p-lg-4" style="margin-top: 5px;">
                  <small class="p-invalid" style="font-size: medium;" v-if="this.disasterCenterDept_error === true">
                    กรุณาเลือกอย่างน้อย 1 ตัวเลือก
                  </small>
                </div>
        </div>
      </div>
      
    </div>
    
    <!-- disasterCenterDept end -->
    </div>
    <div class="p-field p-col ">
      <div class="p-formgrid p-grid p-jc-start" >
    <div class="p-col-1 p-lg-2 p-ml-3">
              <Button
                @click="handleButtonClick()"
                :label="$t('selectBtn')"
                class="p-button-success"
                

              />
            </div>
            </div>
          </div>
    <DataTable
      :value="organizeTable"
      :scrollable="true"
      scrollHeight="500px"
      :paginator="true"
      :rows="10"
      ref="dt"
      :selection="selectOrganization"
      dataKey="organize_id"
      :rowHover="true"
      :filters="filters"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 20, 50]"
      currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      style="width: 95%;"
    >
      <template #empty>{{ $t("TableEmpty") }}</template>
      <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
      <Column
        field="organize_name"
        :header="$t('organize_name')"
        :sortable="true"
        headerStyle="width: 10rem"
      >
        <template #body="dataTable">
          <div hidden>{{ dataTable.data.organize_id }}</div>
          {{ dataTable.data.organize_name }}
        </template>
      </Column>
      <Column
        field="system_name"
        :header="$t('organize_type')"
        :sortable="true"
        headerStyle="width: 10rem"
      >
        <template #body="dataTable">
          {{ dataTable.data.system_name }}
        </template>
      </Column>
      <Column
        field="organize_location"
        :header="$t('organize_location')"
        :sortable="true"
        headerStyle="width: 10rem"
      >
        <template #body="dataTable">
          {{ dataTable.data.organize_location }}
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
export default {
  name: "organize-table-modified",
  // props: ["parentmessage"],
  props: {
    parentmessage : Array,
      checkForm:  {
				type: Boolean,
				default: false
			},
    },
  data() {
    return {
      deselectedItems: [],
      multiSelectClearFilerValue:0,
      isDisabledAmphur: 1,
      isDisabledTambon: 1,
      organize_name: [],
      provinceOptions: [],
      province_select: null,
      amphurOptions: [],
      amphur_select: null,
      tambonOptions: [],
      tambon_select: null,
      organizeTypeOptions: [],
      highwayDeptOptions: [],
      fireStationDeptOptions: [],
      districtAndBangkokDeptOptions: [],
      disasterPreventionStrategyDeptOptions: [],
      secretaryDeptOptions: [],
      disasterDirectedDeptOptions: [],
      disasterCenterDeptOptions: [],

      organizeType_select: null,
      data_selected: [],
      highwayDept_select: null,
      fireStationDept_select: null,
      districtAndBangkokDept_select: null,
      disasterPreventionStrategyDept_select: null,
      secretaryDept_select: null,
      disasterDirectedDept_select: null,
      disasterCenterDept_select: null,

      highwayDept_error: false,
      fireStationDept_error: false,
      districtAndBangkokDept_error: false,
      disasterPreventionStrategyDept_error: false,
      secretaryDept_error: false,
      disasterDirectedDept_error: false,
      disasterCenterDept_error: false,

      organizeTable: [],
      filters: {},
      highwayDept: false,
      fireStationDept: false,
      districtAndBangkokDept: false,
      disasterPreventionStrategyDept: false,
      secretaryDept: false,
      disasterDirectedDept: false,
      disasterCenterDept: false,

      selectOrganization: null,
      fireStationDeptLists: [],
      fireStationDeptLists_select: null,
    };
  },

  async created() {
    
    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-28" },
      })
      .then((response) => {
        (this.organizeTypeOptions = response.data.data.filter(item => item.system_name !== "กองปฏิบัติการดับเพลิงและกู้ภัย 1" 
        &&  item.system_name !== "กองปฏิบัติการดับเพลิงและกู้ภัย 2" 
        && item.system_name !== "กองปฏิบัติการดับเพลิงและกู้ภัย 3" 
        && item.system_name !== "กองปฏิบัติการดับเพลิงและกู้ภัย 4" 
        && item.system_name !== "กองปฏิบัติการดับเพลิงและกู้ภัย 5" 
        && item.system_name !== "กองปฏิบัติการดับเพลิงและกู้ภัย 6"))
        // this.organizeType_select = response.data.data
        // console.log(response.data.data)
          // this.organizeTypeOptions.splice(0, 0, {
          //   system_id: "getall",
          //   system_name: this.$i18n.t("selectAll"),
          // });
      });

  },

  mounted() {
    // this.loadOrganizeTableData();
    this.selectOrganization = this.parentmessage;
    // this.selectOrganization = [...this.this.parentmessage.map(row => row.organize_id)];
  },

  methods: {
    handleButtonClick() {
    
    this.searchOrganization();
    
  },
    
    async searchOrganization() {
      if(this.data_selected === null || this.organizeType_select === null){
        return;
      }
      if(this.fireStationDept_error === true ||
      this.districtAndBangkokDept_error === true ||
      this.disasterPreventionStrategyDept_error === true ||
      this.secretaryDept_error === true ||
      this.disasterDirectedDept_error === true){
       return;
       }
       if(this.highwayDept_select !== null){
        this.data_selected.push(...this.highwayDept_select)
       }
       if(this.fireStationDeptLists_select !== null){
        this.data_selected.push(...this.fireStationDeptLists_select)
       }
       if(this.districtAndBangkokDept_select !== null){
        this.data_selected.push(...this.districtAndBangkokDept_select)
       }
       if(this.disasterPreventionStrategyDept_select !== null){
        this.data_selected.push(...this.disasterPreventionStrategyDept_select)
       }
       if(this.secretaryDept_select !== null){
        this.data_selected.push(...this.secretaryDept_select)
       }
       if(this.disasterDirectedDept_select !== null){
        this.data_selected.push(...this.disasterDirectedDept_select)
       }
       if(this.disasterCenterDept_select !== null){
        this.data_selected.push(...this.disasterCenterDept_select)
       }
   try {
     this.selectOrganization = this.data_selected.filter(organize => organize.system_group_id !== "dg-28")
    //  console.log(this.fireStationDeptLists_select); // Make sure the array is populated
     const response = await this.axios.post(`${this.$url_service}/initial/organize`, {
       body: {
         topic: "search-table-list",
        type: this.selectOrganization,
         name: "",
         organize: "",
         province: this.province_select,
         amphur: this.amphur_select,
         tambon: this.tambon_select,
       },
     });

     this.organizeTable = response.data.data;
     this.organizeType_select = null
     this.data_selected = []
     this.deselectedItems = []
      this.highwayDept_select = null
      this.fireStationDept_select = null
      this.districtAndBangkokDept_select = null
      this.disasterPreventionStrategyDept_select = null
      this.secretaryDept_select = null
      this.disasterDirectedDept_select = null
      this.disasterCenterDept_select = null
     this.fireStationDeptLists_select = null
     this.fireStationDeptLists = null

      this.highwayDept = false
      this.fireStationDept = false
     this.districtAndBangkokDept = false
       this.disasterPreventionStrategyDept = false
       this.secretaryDept = false
       this.disasterDirectedDept = false
       this.disasterCenterDept = false
   } catch (error) {
     console.error(error);
   }
   this.selectItem();
 
},
    selectItem() {
      this.$emit("selectOrganization", this.selectOrganization);
    },
  },
  watch: {
  async organizeType_select(val){
    // this.deselectedItems = this.data_selected.filter(item => !val.includes(item.system_name) && !val.includes(item.organize_name));
    // console.log('this.deselectedItems', this.deselectedItems)
    // this.data_selected = this.data_selected.filter(item => !this.deselectedItems.includes(item));
    // console.log('this.data_selected', this.data_selected) 
    // deselectedItems.forEach(item => {
      //   console.log(`Deselected item: ${item.system_name}`);
      // });
    // console.log(val.filter(item => item.system_name !== 'กองปฏิบัติการดับเพลิงและกู้ภัย'))
    this.highwayDept = false;
    this.fireStationDept = false;
    this.districtAndBangkokDept = false;
    this.disasterPreventionStrategyDept = false;
    this.secretaryDept = false;
    this.disasterDirectedDept = false;
    this.disasterCenterDept = false;

    if(val === null || val.length === 0){
      return;
    //   console.log('this.organizeType_select', this.organizeType_select)
    // console.log('this.data_selected', this.data_selected)
    // console.log('this.districtAndBangkokDept_select', this.districtAndBangkokDept_select)
    }

  for (let i = 0; i < val.length; i++) {
    if (val[i].system_name === "กรมทางหลวง") {
      this.highwayDept = true;
    }
    if (val[i].system_name === "กองปฏิบัติการดับเพลิงและกู้ภัย") {
      this.fireStationDept = true;
      await this.axios
          .post(`${this.$url_service}/initial/organize`, {
            body: {
              topic: "search-table-list",
              type: "",
              name: "",
              organize: val[i].system_name,
              province: this.province_select,
              amphur: this.amphur_select,
              tambon: this.tambon_select,
            },
          })
          .then(response => {
            this.fireStationDeptLists = response.data.data
            // this.fireStationDept_select = response.data.data
            // console.log(this.fireStationDept_select)
          })
    }
    if (val[i].system_name === "สำนักงานเขตและกรุงเทพมหานคร") {
        this.districtAndBangkokDept = true;
      await this.axios
          .post(`${this.$url_service}/initial/organize`, {
            body: {
              topic: "search-table-list",
              type: "",
              name: "",
              organize: val[i].system_name,
              province: this.province_select,
              amphur: this.amphur_select,
              tambon: this.tambon_select,
            },
          })
          .then(response => {
            this.districtAndBangkokDeptOptions = response.data.data
            // this.districtAndBangkokDept_select = response.data.data
          })
      
    }
    if (val[i].system_name === "สำนักงานยุทธศาสตร์การป้องกันสาธารณภัย") {
      this.disasterPreventionStrategyDept = true;
      await this.axios
          .post(`${this.$url_service}/initial/organize`, {
            body: {
              topic: "search-table-list",
              type: "",
              name: "",
              organize: val[i].system_name,
              province: this.province_select,
              amphur: this.amphur_select,
              tambon: this.tambon_select,
            },
          })
          .then(response => {
            // console.log(response.data.data)
            this.disasterPreventionStrategyDeptOptions = response.data.data
            // this.disasterPreventionStrategyDept_select = response.data.data
          })
    }
    if (val[i].system_name === "สำนักงานเลขานุการ") {
      this.secretaryDept = true;
      await this.axios
          .post(`${this.$url_service}/initial/organize`, {
            body: {
              topic: "search-table-list",
              type: "",
              name: "",
              organize: val[i].system_name,
              province: this.province_select,
              amphur: this.amphur_select,
              tambon: this.tambon_select,
            },
          })
          .then(response => {
            // console.log(response.data.data)
            this.secretaryDeptOptions = response.data.data
            
            // this.secretaryDept_select = response.data.data
          })
    }
    if (val[i].system_name === "สำนักงานอำนวยการสาธารณภัย") {
      this.disasterDirectedDept = true;
      await this.axios
          .post(`${this.$url_service}/initial/organize`, {
            body: {
              topic: "search-table-list",
              type: "",
              name: "",
              organize: val[i].system_name,
              province: this.province_select,
              amphur: this.amphur_select,
              tambon: this.tambon_select,
            },
          })
          .then(response => {
            // console.log(response.data.data)
            this.disasterDirectedDeptOptions = response.data.data
            // this.disasterDirectedDept_select = response.data.data
          })
    }
    if (val[i].system_name === "สำนักป้องกันและบรรเทาสาธารณภัย") {
      this.disasterCenterDept = true;
    }
  }
  },
  // async fireStationDept_select(val){
  //   // console.log( this.fireStationDept_select)
  //   if(val === null || val.length === 0){
  //     this.fireStationDeptLists_select = null
  //     // this.fireStationDept_error = true
  //     return;
  //   }

  //   if(val !== null){

  //   for (let i = 0; i < val.length; i++) {
  //   if (val[i].organize_main === "or-000024" ||
  //   val[i].organize_main === "or-000035" ||
  //   val[i].organize_main === "or-000047" ||
  //   val[i].organize_main === "or-000056" ||
  //   val[i].organize_main === "or-000064" || 
  //   val[i].organize_main === "or-000075"
  //   ) {
  //     await this.axios
  //         .post(`${this.$url_service}/initial/organize`, {
  //           body: {
  //             topic: "search-table-list",
  //             type: "",
  //             name: this.fireStationDept_select,
  //             organize: "",
  //             province: this.province_select,
  //             amphur: this.amphur_select,
  //             tambon: this.tambon_select,
  //           },
  //         })
  //         .then(response => {
  //           this.fireStationDeptLists = response.data.data
  //           // this.fireStationDeptLists_select = response.data.data
  //           // this.data_selected.push(...this.fireStationDeptLists_select)
  //         })
  //   }}
  //       // this.data_selected.push(...this.fireStationDeptLists_select)
  //       // for(let index=0; index<this.data_selected.length; index++){
  //       //   this.data_selected.filter(organize => !this.data_selected.includes(organize.organize_name))
  //       // }
  //     } },
  highwayDept_select(val){
    if(val === null || val.length === 0){
      this.highwayDept_select = null
      // this.highwayDept_error = true
    }
    if(val !== null){
      this.highwayDept_error = false
      // this.data_selected.push(...this.highwayDept_select)
      
    }
  },
  fireStationDeptLists_select(val){
    if(val === null || val.length === 0){
      this.fireStationDeptLists_select = null
      // this.highwayDept_error = true
    }
    if(val !== null){
      this.fireStationDept_error = false
     
      
    }
  },
  districtAndBangkokDept_select(val){
    if(val === null || val.length === 0){
      this.districtAndBangkokDept_select = null
      // this.districtAndBangkokDept_error = true
    }
    if(val !== null){
      this.districtAndBangkokDept_error = false
      // this.data_selected.push(...this.districtAndBangkokDept_select)
    }
  },
  disasterPreventionStrategyDept_select(val){
    if(val === null || val.length === 0){
      this.disasterPreventionStrategyDept_select = null
      // this.disasterPreventionStrategyDept_error = true
    }
    if(val !== null){
      this.disasterPreventionStrategyDept_error = false
      // this.data_selected.push(...this.disasterPreventionStrategyDept_select)

    }
  },
  secretaryDept_select(val){
    if(val === null || val.length === 0){
      this.secretaryDept_select = null
      return;
      // this.secretaryDept_error = true
    }
    if(val !== null){
      // console.log(val)
      this.secretaryDept_error = false
      // this.data_selected.push(...this.secretaryDept_select)
      // this.data_selected = this.data_selected.filter(item => item !== val.organize_name)
      // console.log(this.data_selected)
    }
  },
  disasterDirectedDept_select(val){
    if(val === null || val.length === 0){
      this.disasterDirectedDept_select = null
      // this.disasterDirectedDept_error = true
    }
    if(val !== null){
      this.disasterDirectedDept_error = false
      // this.data_selected.push(...this.disasterDirectedDept_select)

    }
  },
  disasterCenterDept_select(val){
    if(val === null || val.length === 0){
      this.disasterCenterDept_select = null
      // this.disasterCenterDept_error = true
    }
    if(val !== null){
      this.disasterCenterDept_error = false
      // this.data_selected.push(...this.disasterCenterDept_select)

    }
  },

//   fireStationDeptLists_select(val){
//     if(val === null || val.length === 0){
//       this.fireStationDeptLists_select = null
//       // this.fireStationDept_error = true
//     }
//     if(val !== null){
//       this.fireStationDept_error = false
//       this.data_selected.push(...this.fireStationDeptLists_select)
//       for (let index = 0; index < this.data_selected.length; index++) {
//   this.data_selected = this.data_selected.filter((organize, i) => {
//     return (
//       i === index ||
//       organize.organize_name !== this.data_selected[index].organize_name
//     );
//   });
// }


//     }
//   },


}
};
</script>

<style scoped>
.multiselect-custom {
    width: 100%;
  .p-multiselect-label:not(.p-placeholder) {
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
  
  .item {
      display: flex;
      align-items: center;
    }
  
  .item-value {
      padding-left: 10px;
      padding-right: 10px;
      border-radius: 3px;
      display: inline-flex;
      margin-right: 0.5rem;
      background-color: var(--primary-color);
      color: var(--primary-color-text);
    }
}
</style>

<style>
@media screen and (max-width: 430px) {
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>
